import styled from 'styled-components'

const Header = styled.header`
    background-color: ${props => props.theme.admin.colors.brandDark};
    color: #ffffff;
    box-shadow: ${props => props.theme.admin.boxShadow};
`

export default Header
